import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import en from "./resources/en";
import pl from "./resources/pl";

export const SUPPORTED_LANGUAGES = ["pl", "en"];

export const resources = {
  pl: {
    translation: pl,
  },
  en: {
    translation: en,
  },
};

void i18n.use(initReactI18next).init({
  fallbackLng: "en",
  supportedLngs: SUPPORTED_LANGUAGES,
  load: "languageOnly",
  interpolation: {
    escapeValue: false,
  },
  resources,
});

export default i18n;
